// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"6b42a80a","990":"0dfa2c17"}[chunkId] + ".chunk.js";
};